import { decode } from 'base-64';
import { useCallback, useEffect, useState } from 'react';
import { storageDataKeys, storageImageKeys, } from './cacheTypes';
export function useCache() {
    const [cachedData, setCachedData] = useState({
        holidayBooking: [],
        teamCalendarEvents: null,
        user: null,
    });
    const [cachedImage, setCachedImage] = useState({
        newOrbitLogo: null,
        abdooLogo64: null,
        abdooLogo128: null,
    });
    const setStateAllDataCaches = useCallback(() => {
        setCacheFunction(storageDataKeys, setCachedData);
    }, []);
    const setStateAllImageCaches = useCallback(() => {
        setCacheFunction(storageImageKeys, setCachedImage);
    }, []);
    useEffect(() => {
        setStateAllDataCaches();
        setStateAllImageCaches();
    }, [setStateAllDataCaches, setStateAllImageCaches]);
    useEffect(() => {
        const setCache = () => {
            setStateAllDataCaches();
            setStateAllImageCaches();
        };
        window.addEventListener('storage', setCache);
        return () => window.removeEventListener('storage', setCache);
    }, [setStateAllDataCaches, setStateAllImageCaches]);
    const setCacheFunction = (keys, setCached) => {
        for (let key = 0; key < keys.length; key++) {
            const cacheFromStorage = localStorage.getItem(keys[key]);
            if (cacheFromStorage === null) {
                return;
            }
            const parsedCache = JSON.parse(cacheFromStorage);
            /* eslint-disable @typescript-eslint/no-explicit-any */
            setCached((prev) => ({ ...prev, [keys[key]]: parsedCache }));
        }
    };
    const getCachedImage = useCallback((type) => {
        switch (type) {
            case 'abdooLogo64':
                return cachedImage.abdooLogo64 ? decode(cachedImage.abdooLogo64) : undefined;
            case 'abdooLogo128':
                return cachedImage.abdooLogo128 ? decode(cachedImage.abdooLogo128) : undefined;
            case 'newOrbitLogo':
                return cachedImage.newOrbitLogo ? decode(cachedImage.newOrbitLogo) : undefined;
        }
    }, [cachedImage]);
    return {
        cachedData,
        getCachedImage,
    };
}
